import { useCallback, useState } from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { SearchBar } from '@/components/ui/SearchBar/SearchBar';

import { WorkdayTable } from './components/table';

export function Workday() {
	const [query, setQuery] = useState<string>('');
	const [isLoading, setIsLoading] = useState(false);
	const [allUsers, setAllUsers] = useState<boolean>(false);

	const handleAllUsersChange = (checked: boolean) => {
		setAllUsers(checked);
	};

	const handleSearch = useCallback((searchTerm: string) => {
		setIsLoading(true);
		try {
			setQuery(searchTerm);
			if (!searchTerm) return;
		} finally {
			setIsLoading(false);
		}
	}, []);
	return (
		<>
			<div>
				<h1 className="mb-4 text-center text-2xl font-semibold">
					Workday ID Management
				</h1>
			</div>
			<div className="mb-4 flex justify-end">
				<div className="flex items-center space-x-4">
					<Checkbox
						id="AllUsers"
						checked={allUsers}
						onCheckedChange={handleAllUsersChange}
					/>
					<Label className="pr-3" htmlFor="AllUsers">
						Get All Users
					</Label>
				</div>
				<SearchBar
					placeholder="Search any user"
					onSearch={handleSearch}
					isLoading={isLoading}
				/>
			</div>
			<WorkdayTable
				searchQuery={query}
				setIsLoading={setIsLoading}
				allUsers={allUsers}
			/>
		</>
	);
}
